import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import $ from 'jquery';
import { Spinner, Modal, Button } from 'react-bootstrap';
import {
  formChangedAction
} from 'actions';
import Moment from "moment";
import TabPage1 from 'components/common/TabPage1';
import { addClientPaymentAPI, clientPaymentListAPI, paymentDetailAction, paymentDetailListAPI, paymentDetailsErrorAction, resetPaymentDeletedAction, updateClientPaymentAPI } from 'actions/ClientPayment/clientPaymentAction';
import { clientListAPI } from 'actions/ClientRegistration/ClientRegistrationAction';
import loader from '../../assets/img/loader.svg'

const tabArray = [
  'Payment List',
  'Payment Details'
];

const listColumnArray = [
  { accessor: 'sl', Header: 'S. No.' },
  { accessor: 'clientName', Header: 'Client Name',
    Cell: ({ value }) => (
      <div className="truncate-text" title={value}>
        {value}
      </div>
    )
  },
  { accessor: 'mobileNo', Header: 'Mobile No.' },
  { accessor: 'totalNoOfCase', Header: 'Total Cases' },
  { accessor: 'amount', Header: 'Amount' }
];

const listColumnArray1 = [
  { accessor: 'sl', Header: 'S. No.' },
  { accessor: 'caseNo', Header: 'Case No.' },
  {
    accessor: 'chequeDate',
    Header: 'Cheque Date',
    Cell: ({ value }) => {
      return value ? Moment(value).format('DD-MM-YYYY') : '';
    },
  },
  {
    accessor: 'paymentDate',
    Header: 'Payment  Date',
    Cell: ({ value }) => {
      return value ? Moment(value).format('DD-MM-YYYY') : '';
    },
  },
  { accessor: 'paymentNo', Header: 'Payment No.' },
  { accessor: 'amount', Header: 'Amount' },
  { accessor: 'deletePaymentDetail', Header: 'Delete' },
];

export const ClientPayment = () => {
  const dispatch = useDispatch();
  const [clientPaymentList, setClientPaymentList] = useState([]);
  const [PaymentDetailList, setPaymentDetailList] = useState([]);
  // const [perPage, setPerPage] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [searchText, setSearchText] = useState('');

  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };
  const getClientsPaymentList = async (page, size = pageSize, searchText) => {
    const data = {
      pageNumber: page,
      pageSize: size,
      SearchText:  searchText ? searchText : "",
      EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode')
    };
    setIsLoading(true);
    await dispatch(
      clientPaymentListAPI(
        data,
        res => {
          setIsLoading(false);
          setClientPaymentList(res.data.data.clientPaymentList);
          setTotalCount(res.data.data.totalCount);
        },
        err => {
          setClientPaymentList([]);
          setIsLoading(false);
          toast.error(err?.data.message, {
            theme: 'colored',
            autoClose: 10000
          });
        },
        headers
      )
    );
  };
  

      const clientPaymentDetailReducer = useSelector(
        state => state.rootReducer.clientPaymentReducer
      );
    
      const paymentDetail = clientPaymentDetailReducer.paymentData;

  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  var formChangedData = formChangedReducer.formChanged;

  let isFormChanged = Object.values(formChangedData).some(
    value => value === true
  );
  const paymentDeleted = useSelector(
    state => state.rootReducer.clientPaymentReducer.paymentDeleted
  );
  
  useEffect(() => {
    if (paymentDeleted) {
      getPaymentDetailList(1, pageSize);
      dispatch(resetPaymentDeletedAction(false));
    }
  }, [paymentDeleted, dispatch]);

  const [formHasError, setFormError] = useState(false);
  const [activeTabName, setActiveTabName] = useState();

  useEffect(() => {
    localStorage.removeItem('EncryptedClientPaymentId');
    getClientList(1)
    getClientsPaymentList(1, pageSize);
  }, []);


  const clearClientPaymentReducers = () => {
    dispatch(paymentDetailsErrorAction(undefined));
    dispatch(paymentDetailAction(undefined));
    dispatch(formChangedAction(undefined));
    localStorage.removeItem("EncryptedClientPaymentId")
  };

  $('[data-rr-ui-event-key*="Payment List"]')
    .off('click')
    .on('click', function () {
      let isDiscard = $('#btnDiscard').attr('isDiscard');
      if (isDiscard != 'true' && isFormChanged) {
        setModalShow(true);
        setTimeout(function () {
          $('[data-rr-ui-event-key*="' + activeTabName + '"]').trigger('click');
        }, 50);
      } else {
        clearClientPaymentReducers();
        localStorage.removeItem('EncryptedClientPaymentId');
        $('#btnNew').show();
        $('#btnSave').hide();
        $('#btnCancel').hide();
        $('[data-rr-ui-event-key*="Payment Details"]').attr('disabled', true);
        $('[data-rr-ui-event-key*="Payment List"]').attr('disabled', false);
        $('#AddPaymentDetailsForm').get(0).reset();
        getPaymentDetailList(1,pageSize)
        $('#btnDiscard').attr('isDiscard', false);
      }
    });

    $('[data-rr-ui-event-key*="Payment Details"]')
    .off('click')
    .on('click', function () {
      setActiveTabName('Payment Details');
      $('#btnNew').hide();
      $('#btnSave').show();
      $('#btnCancel').show();
    });


  const newDetails = () => {
    $('[data-rr-ui-event-key*="Details"]').attr('disabled', false);
    $('[data-rr-ui-event-key="Payment Details"]').trigger('click');
    $('#btnSave').attr('disabled', false);
    clearClientPaymentReducers();
  };

  const cancelClick = () => {
    $('#btnExit').attr('isExit', 'false');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      $('[data-rr-ui-event-key*="Payment List"]').trigger('click');
    }
  };

  const exitModule = () => {
    $('#btnExit').attr('isExit', 'true');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      window.location.href = '/dashboard';
    }
  };

  const discardChanges = () => {
    $('#btnDiscard').attr('isDiscard', 'true');
    if ($('#btnExit').attr('isExit') == 'true')
      window.location.href = '/dashboard';
    else $('[data-rr-ui-event-key*="List"]').trigger('click');

    setModalShow(false);
  };

  const paymentDetailValidation = () => {

      const caseNoErr = {};
      const chequeDateErr = {};
      const paymentDateErr = {};
      const amountErr = {};
      const paymentTypeErr = {};
      const paymentNoErr = {};
  
      let isValid = true;
  
      if (!paymentDetail.caseNo) {
        caseNoErr.caseNoEmpty = 'Select case no';
        isValid = false;
        setFormError(true);
      }
  
      if (paymentDetail.paymentType == "Cheque" && !paymentDetail.chequeDate) {
        chequeDateErr.chequeDateEmpty = 'Select chequeDate date';
        isValid = false;
        setFormError(true);
      }
  
      if ( 
        !paymentDetail.paymentDate ||
        paymentDetail.paymentDate === ''
      ) {
        paymentDateErr.paymentDateEmpty = 'Select payment date';
        isValid = false;
        setFormError(true);
      }
  
  
      if (paymentDetail.amount <= 0 || paymentDetail.amount == null) {
        amountErr.amountEmpty = 'Please enter amount';
        isValid = false;
        setFormError(true);
      }
  
      if (!paymentDetail.paymentType) {
        paymentTypeErr.paymentTypeEmpty = 'Select payment type';
        isValid = false;
        setFormError(true);
      }else if (paymentDetail.paymentType != 'Cash') {
        if (!paymentDetail.paymentNo) {
          paymentNoErr.paymentNoEmpty = 'Enter payment no.';
          isValid = false;
          setFormError(true);
        }
      
    }

    if (!isValid) {
      var errorObject = {
        caseNoErr,
        chequeDateErr,
        amountErr,
        paymentTypeErr,
        paymentNoErr,
        paymentDateErr
      };
      dispatch(paymentDetailsErrorAction(errorObject));
    }

    return isValid;
  };

  const addPaymentDetail = async () => {

    if (paymentDetailValidation()) {
    const paymentData = {
      encryptedAdvocateCode: localStorage.getItem(
              'EncryptedAdvocateCode'
            ),
            encryptedClientCode:  paymentDetail.encryptedClientCode ? paymentDetail.encryptedClientCode : localStorage.getItem("ClientCode"),
            clientName: localStorage.getItem("ClientName"),
            clientCaseNo: paymentDetail.caseNo,
            chequeDate: paymentDetail.chequeDate ? paymentDetail.chequeDate : null ,
            paymentDate: paymentDetail.paymentDate,
            paymentType: paymentDetail.paymentType,
            paymentNo: paymentDetail.paymentNo
              ? paymentDetail.paymentNo
              : '',
              payAmount: parseFloat(paymentDetail.amount),
            addUser: localStorage.getItem('LoginUserName'),

          };
          const keys = [
            'ClientName',
            'paymentNo',
            'addUser'
          ];
          for (const key of Object.keys(paymentData).filter(key => keys.includes(key))) {
            paymentData[key] = paymentData[key] ? paymentData[key].toUpperCase() : '';
          }
      setIsLoading(true);
      if (formChangedData.paymentDetailAdd) {
      await dispatch(
        addClientPaymentAPI(
          paymentData,
          response => {
            setIsLoading(false);
            toast.success(` ${response.data.message}`, {
              theme: 'colored',
              autoClose: 10000
            });
            updateCallback(true, response.data.data.encryptedClientPaymentId);
            setModalShow(false);
            localStorage.setItem(
              'EncryptedClientPaymentId',
              response.data.data.encryptedClientPaymentId
            );
          },
          err => {
            setIsLoading(false);
            toast.error(err?.data.message, {
              theme: 'colored',
              autoClose: 10000
            });
          },
          headers
        )
      );
    }
    }
  };

  const updateCallback = (isAddAdvocate = false, encryptedClientPaymentId) => {
    setModalShow(false);
    dispatch(paymentDetailsErrorAction(undefined));
    dispatch(formChangedAction(undefined));

    if (!isAddAdvocate) {
      toast.success('Payment Details updated successfully!', {
        theme: 'colored'
      });
    } else {
      dispatch(
        paymentDetailAction({
          ...paymentDetail,
          encryptedClientPaymentId: encryptedClientPaymentId
        })
      );
    }

    $('#btnSave').attr('disabled', true);
    $('[data-rr-ui-event-key*="' + activeTabName + '"]').trigger('click');

    getClientsPaymentList(1, pageSize);
  };

  const updatePaymentDetails = async () => {
    if (paymentDetailValidation()) {
      const requestData = {
        encryptedAdvocateCode: localStorage.getItem(
                'EncryptedAdvocateCode'
              ),
              encryptedClientPaymentId:paymentDetail.encryptedClientPaymentId,
              encryptedClientCode:  paymentDetail.clientCode ? paymentDetail.clientCode : localStorage.getItem("ClientCode"),
            caseNo: paymentDetail.caseNo,
              chequeDate: paymentDetail.chequeDate ?  paymentDetail.chequeDate : null ,
              paymentDate: paymentDetail.paymentDate,
              paymentType: paymentDetail.paymentType,
              paymentNo: paymentDetail.paymentNo
                ? paymentDetail.paymentNo
                : '',
              amount: parseFloat(paymentDetail.amount),
                modifyUser: localStorage.getItem('LoginUserName'),
            };
            const keys = [ 
              "paymentNo",
              'modifyUser'
            ];
            for (const key of Object.keys(requestData).filter(key => keys.includes(key))) {
              requestData[key] = requestData[key] ? requestData[key].toUpperCase() : '';
            }
            var hasError = false;
            setIsLoading(true);
                if (formChangedData.paymentDetailUpdate) {
                   await dispatch(
                    updateClientPaymentAPI(
                      requestData,
                        res => {
                          setIsLoading(false);
                          setModalShow(false);
                          // toast.success(res?.data.message, {
                          //   theme: 'colored',
                          //   autoClose: 10000
                          // });
                        },
                        err => {
                          setIsLoading(false)
                          toast.error(err?.data.message, {
                            theme: 'colored',
                            autoClose: 10000
                          });
                          hasError = true;
                        },
                        headers
                      )
                    );
                  }
                  if (!hasError) {
                    updateCallback();
                  }
    }
  };
  
    const getClientList = async (page, size = pageSize) => {
      const data = {
        pageNumber: page,
        pageSize: size,
        SearchText: '',
        EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
        isDropDown: true
      };
      setIsLoading(true);
      await dispatch(
        clientListAPI(
          data,
          res => {
            setIsLoading(false)
            let clientData = [];
  
            if (res.data.data.clientList.length > 0)
              res.data.data.clientList.forEach(client => {
                clientData.push({
                  key: client.clientName,
                  value: client.clientCode,
                  label: client.clientName,
                });
              });
            setClientList(clientData);
            if (res.data.data.clientList && res.data.data.clientList.length === 1) {
              getPaymentDetailList(1, pageSize, "", res.data.data.clientList[0].clientCode)
            }
          },
          err => {
            setClientList([]);
            setIsLoading(false)
            console.log(err?.data.message);
          },
          headers
        )
      );
    };


    const getPaymentDetailList = async (page, size = pageSize, searchText, clientCode) => {
      const data = {
        pageNumber: page,
        pageSize: size,
        SearchText:  searchText ? searchText : "",
        EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
        clientCode: clientCode ? clientCode : localStorage.getItem('ClientCode')
      };
      setIsLoading(true);
      await dispatch(
        paymentDetailListAPI(
          data,
          res => {
            setIsLoading(false);
            setPaymentDetailList(res.data.data.paymentDetailList);
            setTotalCount(res.data.data.totalCount);
            setTotalAmount(res.data.data.totalAmount);
          },
          err => {
            setPaymentDetailList([]);
            setIsLoading(false);
            toast.error(err?.data.message, {
              theme: 'colored',
              autoClose: 10000
            });
          },
          headers
        )
      );
    };

    const handleFieldChange = e => {
      if (e.target.value) {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const clientCode = e.target.value;
        const clientName = selectedOption.dataset.key || selectedOption.label;
        localStorage.setItem("ClientCode", clientCode);
        localStorage.setItem("ClientName", clientName);
        getPaymentDetailList(1, pageSize, searchText, clientCode);
      } else {
        localStorage.removeItem("ClientCode");
        localStorage.removeItem("ClientName");
        localStorage.removeItem("EncryptedClientCode");
    
        getClientsPaymentList(1, pageSize);
      }
    };
    
    const handleClick = () => {
      if (!localStorage.getItem("ClientCode")) {
        toast.error("Please select client", {
          theme: 'colored',
          autoClose: 10000
        });
      }
  };

  return (
    <>
      {/* {isLoading ? (
        <Spinner
          className="position-absolute start-50 loader-color"
          animation="border"
        />
      ) : null} */}
            {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Confirmation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Do you want to save changes?</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              // onClick={() => checkEmailMobileValidation()}
            >
              Save
            </Button>
            <Button
              variant="danger"
              id="btnDiscard"
              onClick={() => discardChanges()}
            >
              Discard
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <TabPage1
       listData={localStorage.getItem("ClientCode") ? PaymentDetailList : clientPaymentList}
        listColumnArray={localStorage.getItem("ClientCode") ? listColumnArray1 : listColumnArray}
        tabArray={tabArray}
        module="ClientPayment"
        totalAmount = {totalAmount}
        saveDetails={paymentDetail.encryptedClientPaymentId ? updatePaymentDetails : addPaymentDetail}
        newDetails={localStorage.getItem("ClientCode") ? newDetails : handleClick}
        cancelClick={cancelClick}
        exitModule={exitModule}
        tableFilterOptions={clientList}
        tableFilterName={'Client'}
        supportingMethod1={handleFieldChange}
        pageSize={pageSize}
        setPageSize={(value)=> setPageSize(value)}
        searchText={searchText}
        setSearchTextValue={(value)=> setSearchText(value)}
        fetchList = {localStorage.getItem("ClientCode") ? getPaymentDetailList : getClientsPaymentList}
        listCount={totalCount}
      />
    </>
  );
};

export default ClientPayment;
